// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-primary-navigation .nuxt-link--active:after{--tw-bg-opacity:1;background-color:rgba(47,83,176,var(--tw-bg-opacity));border-radius:9999px;content:\"\";display:block;height:3px;margin-left:auto;margin-right:auto;width:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
